// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
// local
// css
import './CustomToggle.scss';

class CustomToggle extends Component {
    render() {
        const { className, checked, onChange } = this.props;
        return (
            <Toggle
                className={className}
                icons={{
                    checked: 'ON',
                    unchecked: 'OFF',
                }}
                checked={checked}
                onChange={onChange}
            />
        );
    }
}

CustomToggle.propTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
};

export default CustomToggle;
